import { ChartType } from 'chart.js'
import _ from 'lodash'

import base from './base'

export default _.merge({}, base, {
  type: 'line' as ChartType,
})
